import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import heartWithCoin from "../../../assets/icons/heartWithCoin.svg";
import { BoardContext } from "../../../context";
import { PinkNotification } from "../../atoms";

const TippingSecionAnoncement = () => {
    const { t } = useTranslation();
    const { setIsDilemmaOwnerAnouncementDone } = useContext(BoardContext);

    useEffect(() => {
        const textAnimate = setTimeout(() => {
            setIsDilemmaOwnerAnouncementDone("");
        }, 10000);

        return () => clearTimeout(textAnimate);
    }, [setIsDilemmaOwnerAnouncementDone])
    
    return (
        <div className="dilemma_owner_anouncement_wrapper tipping_section_anouncement center_horizontally_and_vertically full_screen_vw_vh">
            <div className="tipping_section_anouncement_image_wrapper center_horizontally_and_vertically">
                <div className="tipping_secion_anouncement_glow"></div>
                <img className="tipping_section_anouncement_image center_horizontally_and_vertically" src={heartWithCoin} alt="round" />
                <PinkNotification notificationWidthVW={25} notificationRenderingSide="right" text={t("youCanNowTipSolutionsIfYouLikeThemText")} moveFromTop={0} />
            </div>
        </div>
    )
}

export default TippingSecionAnoncement; 